import {
    IgAudienceCity,
    IgAudienceCountry,
    IgAudienceGenderAge,
} from '@core/models/ApiFields/ig-entities';
import { DimCategory } from '@features/social-analysis/models/IDimensions';

export const AUD_ENTITIES = {
    GENDER: 'gender',
    AGE: 'age',
    CITY: 'city',
    COUNTRY: 'country',
    GENDER_AGE: 'gender_age',
} as const;

export const AUD_TIMEF = {
    LAST_14_DAYS: 'last_14_days',
    LAST_30_DAYS: 'last_30_days',
    LAST_90_DAYS: 'last_90_days',
    PREV_MONTH: 'prev_month',
    THIS_MONTH: 'this_month',
    THIS_WEEK: 'this_week',
    LIFETIME: 'lifetime',
} as const;

export const timeframeOpts: DimCategory[] = [
    {
        display: '',
        values: [
            // {
            //     display: 'Lifetime',
            //     value: AUD_TIMEF.LIFETIME,
            // },
            {
                display: 'Last 14 days',
                value: AUD_TIMEF.LAST_14_DAYS,
            },
            {
                display: 'Last 30 days',
                value: AUD_TIMEF.LAST_30_DAYS,
            },
            {
                display: 'Last 90 days',
                value: AUD_TIMEF.LAST_90_DAYS,
            },
            {
                display: 'Previous month',
                value: AUD_TIMEF.PREV_MONTH,
            },
            {
                display: 'This month',
                value: AUD_TIMEF.THIS_MONTH,
            },
            {
                display: 'This week',
                value: AUD_TIMEF.THIS_WEEK,
            },
        ],
    },
];

export type AudEntities = (typeof AUD_ENTITIES)[keyof typeof AUD_ENTITIES];
export type AudTimefKeys = keyof typeof AUD_TIMEF;
export type AudTimef = (typeof AUD_TIMEF)[AudTimefKeys];
export type GenderAgeStore =
    | {
          [x: string]: string | Record<string, any>[];
          data: Record<string, any>[];
      }[]
    | null;

/* API */

export const AUD_API_ENDP = {
    [AUD_ENTITIES.GENDER]: '/audience/gender_age',
    [AUD_ENTITIES.AGE]: '/audience/gender_age',
    [AUD_ENTITIES.GENDER_AGE]: '/audience/gender_age',
    [AUD_ENTITIES.COUNTRY]: '/audience/country',
    [AUD_ENTITIES.CITY]: '/audience/city',
};

export const AUD_API_FIELDS = {
    [AUD_ENTITIES.GENDER]: [
        IgAudienceGenderAge.getPrefixed('gender'),
        IgAudienceGenderAge.getPrefixed('usersPercentage'),
    ],
    [AUD_ENTITIES.AGE]: [
        IgAudienceGenderAge.getPrefixed('ageRange'),
        IgAudienceGenderAge.getPrefixed('usersPercentage'),
    ],
    [AUD_ENTITIES.GENDER_AGE]: [
        IgAudienceGenderAge.getPrefixed('gender'),
        IgAudienceGenderAge.getPrefixed('usersPercentage'),
    ],
    [AUD_ENTITIES.COUNTRY]: [
        IgAudienceCountry.getPrefixed('country'),
        IgAudienceCountry.getPrefixed('users'),
        IgAudienceCountry.getPrefixed('usersPercentage'),
    ],
    [AUD_ENTITIES.CITY]: [
        IgAudienceCity.getPrefixed('city'),
        IgAudienceCity.getPrefixed('users'),
        IgAudienceCity.getPrefixed('usersPercentage'),
    ],
};

export const AUD_API_BREAKD = {
    [AUD_ENTITIES.GENDER_AGE]: [IgAudienceGenderAge.getPrefixed('ageRange')],
    [AUD_ENTITIES.GENDER]: [],
    [AUD_ENTITIES.AGE]: [],
    [AUD_ENTITIES.COUNTRY]: [],
    [AUD_ENTITIES.CITY]: [],
};

export const AUD_API_SORT = {
    [AUD_ENTITIES.GENDER_AGE]: [],
    [AUD_ENTITIES.GENDER]: [],
    [AUD_ENTITIES.AGE]: [],
    [AUD_ENTITIES.COUNTRY]: [IgAudienceCountry.getPrefixed('users')],
    [AUD_ENTITIES.CITY]: [IgAudienceCity.getPrefixed('users')],
};
